import React from "react";
import { ExternalLink, Image, MessageSquareText, PackageCheck } from "lucide-react";

const AdminPage = () => (
  <main className="min-h-screen bg-[#F6F7F1] px-4 py-16 sm:px-6">
    <section className="mx-auto max-w-3xl rounded-3xl bg-white p-8 shadow-sm sm:p-12">
      <p className="mb-3 text-sm font-semibold uppercase tracking-[0.18em] text-[#E5007D]">
        Espace de gestion
      </p>
      <h1 className="mb-4 font-playfair text-3xl font-bold text-gray-900 sm:text-4xl">
        Modifier le site
      </h1>
      <p className="mb-8 leading-relaxed text-gray-600">
        Les contenus et les photos sont gérés dans Pages CMS avec ton compte GitHub.
        Après l'enregistrement, les changements sont ajoutés au dépôt et Netlify
        republie automatiquement le site. Le cadrage du logo se règle dans la
        rubrique « Cadrage du logo » de Pages CMS.
      </p>

      <a
        href="https://app.pagescms.org/"
        target="_blank"
        rel="noreferrer"
        className="inline-flex items-center gap-2 rounded-full bg-[#E5007D] px-6 py-3 font-semibold text-white transition-colors hover:bg-[#c70069]"
      >
        Ouvrir Pages CMS <ExternalLink className="h-4 w-4" />
      </a>

      <div className="mt-10 grid gap-4 border-t border-gray-100 pt-8 sm:grid-cols-3">
        <div className="flex items-start gap-3 text-sm text-gray-600">
          <Image className="mt-0.5 h-5 w-5 shrink-0 text-[#E5007D]" />
          <span>Photos de la bannière et des réalisations</span>
        </div>
        <div className="flex items-start gap-3 text-sm text-gray-600">
          <PackageCheck className="mt-0.5 h-5 w-5 shrink-0 text-[#E5007D]" />
          <span>Présentation et tarifs affichés sur le site</span>
        </div>
        <div className="flex items-start gap-3 text-sm text-gray-600">
          <MessageSquareText className="mt-0.5 h-5 w-5 shrink-0 text-[#E5007D]" />
          <span>Avis à publier après validation</span>
        </div>
      </div>
      <p className="mt-8 text-sm text-gray-500">
        Si le dépôt n'apparaît pas dans Pages CMS, connecte-toi avec le compte
        GitHub propriétaire du dépôt et autorise l'application Pages CMS.
      </p>
    </section>
  </main>
);

export default AdminPage;
